export default __webpack_public_path__ + "static/googleCalendarBLue-6f2d905ddc953fc323e6eafda968a667.jpg";